export enum ProductUnit {
    L = 'L',
    KG = 'KG',
    BARREL = 'BARREL',
    MWH = 'MWH',
    MMBTU = 'MMBTU',
    PIECE = 'PIECE',
}
